import React, { type FC } from "react";
import { type RouteData } from "~/foundation/Jss";
import { Schema } from "~/foundation/Tracking/Schema";
import { getFaqAccordionQuestions } from "./getFaqAccordionQuestions";

type FaqSchemaProps = {
	route: RouteData;
};

export const FaqSchema: FC<FaqSchemaProps> = ({ route }) => {
	const questions = getFaqAccordionQuestions(route);

	if (questions.length === 0) {
		return null;
	}

	return (
		<Schema schema={{
			"@context": "https://schema.org",
			"@type": "FAQPage",
			"mainEntity": questions.map((question) => ({
				"@type": "Question" as const,
				"name": question.name,
				"acceptedAnswer": {
					"@type": "Answer" as const,
					"text": question.text,
				},
			})),
		}} />
	);
};
